module.exports = __webpack_public_path__ + "img/MEDIA114.ac1b1998.jpg";